import { useTranslation } from 'libs/i18n';
import { IconButton } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { Section } from 'modules/client/common/components';

import { useFormContext } from '../../../forms/bankAccountsForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const BankAccountsSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();

  const { readOnly, setFieldValue, values } = useFormContext();

  const onAddBankAccount = () => {
    const bankAccounts = [
      ...values.bankAccounts,
      { country: null, swiftCode: '' },
    ];
    setFieldValue('bankAccounts', bankAccounts, false);
  };

  const onRemoveBankAccount = (index: number) => {
    const bankAccounts = [...values.bankAccounts];
    bankAccounts.splice(index, 1);
    setFieldValue('bankAccounts', bankAccounts, false);
  };

  return (
    <Section
      datax="bankAccountsSection"
      headerRight={
        !readOnly && (
          <IconButton
            icon={<Icon.Plus size={16} />}
            mode="outlined"
            sizeVariant="xs"
            onClick={onAddBankAccount}
          />
        )
      }
      title={t('client.client.bankAccounts.title')}
    >
      <FormContent {...formProps} onRemoveBankAccount={onRemoveBankAccount} />
    </Section>
  );
};
